import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [productOpen, setProductOpen] = useState(false);

  const location = useLocation();

  const handleScroll = (id) => {
    if (location.pathname === "/") {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    } else {
      window.location.href = `/#${id}`;
    }
    setIsOpen(false);
  };

  return (
    <div className="shadow-md">
      <div className="flex justify-between items-center px-4 md:px-8 py-4">
        
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
          <img
            src={"/images/logo.png"}
            alt="Aranya Nutraceuticals"
            className="h-8 w-auto md:h-10"
          />

          <span className="text-lg md:text-xl font-bold">
            Aranya Nutraceuticals
          </span>
        </Link>

        {/* Desktop Menu */}
        <div className="hidden md:flex gap-6 items-center">

          <button onClick={() => handleScroll("about")}>
            About
          </button>

          {/* Products Dropdown */}
          {/* Products Dropdown */}
<div className="relative group py-2">
  
  <button className="hover:text-green-600 transition">
    Products
  </button>

  {/* Dropdown Menu */}
  <div className="absolute left-0 top-full hidden group-hover:flex flex-col bg-white shadow-lg rounded-md min-w-[180px] z-50">

    <Link
      to="/oils"
      className="px-4 py-3 hover:bg-green-100 whitespace-nowrap"
    >
      Essential Oils
    </Link>

    <Link
      to="/extracts"
      className="px-4 py-3 hover:bg-green-100 whitespace-nowrap"
    >
      Extracts
    </Link>
    <Link
      to="/dry-leaves"
      className="px-4 py-3 hover:bg-green-100 whitespace-nowrap"
    >
      Dry Leaves
    </Link>

  </div>
</div>

          {/* <Link to="/certificates" className="hover:text-green-600 transition">
            FSSAI Certificate
          </Link> */}

          <button
            onClick={() => handleScroll("contact")}
          >
            Contact
          </button>

        </div>

        {/* Hamburger Icon */}
        <div
          className="md:hidden text-2xl cursor-pointer"
          onClick={() => setIsOpen(!isOpen)}
        >
          ☰
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden flex flex-col items-center gap-4 pb-4 bg-white shadow">

          <button
            className="hover:text-green-600 transition"
            onClick={() => handleScroll("about")}
          >
            About
          </button>

          {/* Mobile Products Dropdown */}
          <div className="flex flex-col items-center">
            
            <button
              className="hover:text-green-600 transition"
              onClick={() => setProductOpen(!productOpen)}
            >
              Products ▼
            </button>

            {productOpen && (
              <div className="flex flex-col mt-2 gap-2">

                <Link
                  to="/oils"
                  onClick={() => setIsOpen(false)}
                  className="text-center"
                >
                  Essential Oils
                </Link>

                <Link
                  to="/extracts"
                  onClick={() => setIsOpen(false)}
                  className="text-center"
                >
                  Extracts
                </Link>

                <Link
                  to="/dry-leaves"
                  onClick={() => setIsOpen(false)}
                  className="text-center"
                >
                  Dry Leaves
                </Link>

              </div>
            )}
          </div>

          {/* <Link to="/certificates" onClick={() => setIsOpen(false)}>
            FSSAI Certificate
          </Link> */}

          <button
            className="hover:text-green-600 transition"
            onClick={() => handleScroll("contact")}
          >
            Contact
          </button>

        </div>
      )}
    </div>
  );
};

export default Navbar;